import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Box, Button, Container, Typography } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../styles/StylesConstantes";
import { getUsuarios } from "../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Add, Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ItemsHeader from "./components/ItemsHeader";
import ItemsTableComponent from "./components/ItemsTableComponent";


function ItemsPage() {
    const [loading, setLoading] = useState(false);
    const [dataItems, setDataItems] = useState([]);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);
    const [loadingCargar, setLoadingCargar] = useState(false);

    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);


    useEffect(() => {
        if (stateToken) {
            handleListarUsuarios();
        }
    }, [stateToken]);

    const handleListarUsuarios = () => {

        getUsuarios(stateToken?.token, 1, 10)
            .then((response) => {
                // console.log("response-getUsuarios", response);
                if (response.data.length > 0) {
                    setDataItems(response.data);
                    setLoading(true);
                } else {
                    setDataItems([]);
                    setLoading(true);
                }
            })
            .catch((error) => {
                console.log("error-getUsuarios", error);
                setDataItems([]);
                setLoading(true);
            });
    };









    //=============================================funcion para editar
    const handleEditClick = (id, row) => () => {
        // console.log('Edit', id, row);
        history('/app/admin/atc/itmes-detalle/' + id, {
            state: { data: row }
        });
    };


    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataItems(dataItems.filter((row) => row.id !== id));
    }





    // Funciones para manejar el modal
    const handleAddItem = () => {
        history('/app/admin/atc/itmes-agregar');
    };


    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };





    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarEventos = (page = 1) => {

        // let body = {
        //     page: page,
        //     per_page: perPage,
        //     estado: statusFilter,
        //     titulo: searchFilter
        // };
        // console.log("body-handleApiFiltrarLocales", body);


        // setLoadingCargar(true);

        // getFiltrarEventos(stateToken?.access_token, body)
        //     .then(response => {
        //         // console.log("response==>", response);

        //         setLoadingCargar(false);
        //         // setMetaPaginacion(response.meta);

        //         if (response.data.length > 0) {
        //             setDataHistorial(response.data);
        //             setLoading(true);
        //         } else {
        //             setDataHistorial([]);
        //             setLoading(true);
        //         }

        //         setMetaPaginacion({
        //             current_page: response?.current_page,
        //             per_page: response?.per_page,
        //             total: response?.total,
        //             last_page: response?.last_page
        //         });


        //     })
        //     .catch(error => {
        //         console.log("error==>", error);
        //         setDataHistorial([]);
        //         setLoading(true);
        //         setLoadingCargar(false);
        //     })
    };



    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div className="max-w-7xl mx-auto">

                        <ItemsHeader
                            title="Items"
                            subtitle="Administra y supervisa los items de la plataforma."
                            handleAdd={handleAddItem}
                        />




                        <div>
                            <ItemsTableComponent
                                data={dataItems}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarEventos}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="max-w-7xl mx-auto">
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </HeaderCustom>
    );
}

export default ItemsPage;